import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useFpCampaignProductsStore } from '@cart-services/hooks/useFpCampaignProductsStore'
import { THIRD_PARTY_ORDER_ERROR_CODES } from '@constants'
import { LoginPortalGroupBuying } from '@cosign/components/cosign/login/group-buying/LoginPortalGroupBuying'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { AppBar } from '../../components/AppBar/AppBar'
import { LoaderBuygather } from '../../components/LoaderFullPage/LoaderBuygather'
import { LeftHeader } from '../../components/TheCampaignHeader'

export function CampaignGroupBuying() {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { projectCode } = useFpCampaignProductsStore()
  const { destructuredData: exhibitorSettings, isLoading: isActivityLoading } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const { isLoading: isCampaignMemberLoading } = useApiCampaignMember({ code: campaignCodeFromUrl }, {
    onError: (error) => {
      const isAuthenticationError = error?.response?.status === 403 && error?.response?.data.error?.code === THIRD_PARTY_ORDER_ERROR_CODES.AUTHENTICATION_ERROR
      const isPermissionDeny = error?.response?.status === 403 && error?.response?.data.error?.code === THIRD_PARTY_ORDER_ERROR_CODES.INVALID_PARAMETERS
      if (isAuthenticationError || isPermissionDeny) {
        window.location.href = `${window.location.origin}/campaigns/${campaignCodeFromUrl}/login`
      }
    },
  })

  if (isActivityLoading || !projectCode || !exhibitorSettings?.region || !exhibitorSettings.email_domain || isCampaignMemberLoading) {
    return (
      <LoaderBuygather fontSize={60} />
    )
  }

  const emailDomain = exhibitorSettings.email_domain.startsWith('@') ? exhibitorSettings.email_domain : `@${exhibitorSettings.email_domain}`

  return (
    <>
      <AppBar left={<LeftHeader logoHref={`/campaigns/${campaignCodeFromUrl}/login`} />} />
      <LoginPortalGroupBuying
        projectCode={projectCode}
        backLoginUrl={`/campaigns/${campaignCodeFromUrl}/logout`}
        countryCode={exhibitorSettings?.region}
        fallbackUrl={`${window.location.origin}/campaigns/${campaignCodeFromUrl}/`}
        redirectUrl={`${window.location.origin}/campaigns/${campaignCodeFromUrl}/`}
        tokenLoginUrl={`${window.location.origin}/campaigns/${campaignCodeFromUrl}/auth-processing-with-group-buying`}
        emailDomain={emailDomain}
      />
    </>
  )
}
